// components/data-quality/AduanaQualityComparison.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AduanaQualityComparison = ({ aduanaStats }) => {
  // Sort by booking count
  const sortedAduanas = [...aduanaStats].sort(
    (a, b) => b.totalBookings - a.totalBookings
  );

  // Data for vertical bar chart
  const chartData = {
    labels: sortedAduanas.map((item) => `Aduana ${item.aduana}`),
    datasets: [
      {
        label: "Average Quality Score",
        data: sortedAduanas.map((item) => item.averageQualityScore),
        backgroundColor: sortedAduanas.map((item) => {
          const score = item.averageQualityScore;
          if (score >= 90) return "rgba(34, 197, 94, 0.8)"; // Green
          if (score >= 70) return "rgba(59, 130, 246, 0.8)"; // Blue
          if (score >= 50) return "rgba(234, 179, 8, 0.8)"; // Yellow
          if (score >= 30) return "rgba(249, 115, 22, 0.8)"; // Orange
          return "rgba(239, 68, 68, 0.8)"; // Red
        }),
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  // Options for vertical bar chart
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Quality Score: ${context.parsed.y.toFixed(1)}%`;
          },
          afterLabel: (context) => {
            const aduana = sortedAduanas[context.dataIndex];
            return [
              `Bookings: ${aduana.totalBookings}`,
              `Abandoned: ${aduana.abandonedPercentage.toFixed(1)}%`,
              `Valid Status: ${aduana.validStatusPercentage.toFixed(1)}%`,
              `Valid Dates: ${aduana.validDatePercentage.toFixed(1)}%`,
            ];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Quality Score (%)",
          font: {
            size: 11,
          },
        },
        ticks: {
          callback: (value) => `${value}%`,
        },
      },
      x: {
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-800 flex items-center">
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="text-blue-600 mr-2"
          />
          Aduana Quality Comparison
        </h3>
        <div className="text-sm text-gray-500">
          {sortedAduanas.length} entry points
        </div>
      </div>

      <div className="flex-grow">
        <Bar data={chartData} options={chartOptions} />
      </div>

      <div className="mt-2 text-xs text-gray-500">
        <p>
          Quality scores by customs entry points (Aduanas) to identify
          location-specific issues.
        </p>
      </div>
    </div>
  );
};

export default AduanaQualityComparison;
